import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { waLink } from "@/lib/fmt";

export function WhatsAppFloat({ message, offset }) {
  const { settings } = useStore();
  const msg = message || `Olá! Estou em ${document.title} e quero ajuda da Nativa Amazon.`;
  return (
    <a href={waLink(settings?.whatsapp_e164 || "5531987686700", msg)} target="_blank" rel="noreferrer" aria-label="Falar no WhatsApp" data-testid="whatsapp-float"
      className={`fixed right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-na-wa text-white shadow-lg shadow-black/20 transition-transform hover:scale-105 ${offset ? "bottom-24 lg:bottom-6" : "bottom-6"}`}>
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}

function loadPixels(px) {
  if (px.ga4_id && !window.gtag) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${px.ga4_id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", px.ga4_id);
  }
  if (px.meta_pixel_id && !window.fbq) {
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq("init", px.meta_pixel_id);
    window.fbq("track", "PageView");
  }
}

export function CookieBanner() {
  const { settings } = useStore();
  const [c, setC] = useState(() => JSON.parse(localStorage.getItem("na_cookies") || "null"));
  const [prefs, setPrefs] = useState({ medicao: false, marketing: false });
  const [more, setMore] = useState(false);
  useEffect(() => {
    if (c && settings?.pixels) loadPixels({ ga4_id: c.medicao ? settings.pixels.ga4_id : "", meta_pixel_id: c.marketing ? settings.pixels.meta_pixel_id : "" });
  }, [c, settings]);
  const save = (v) => {
    const val = { essenciais: true, ...v, em: new Date().toISOString() };
    localStorage.setItem("na_cookies", JSON.stringify(val));
    setC(val);
  };
  if (c) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-xl rounded-[28px] border border-na-line bg-white p-5 shadow-2xl" role="dialog" aria-label="Cookies" data-testid="cookie-banner">
      <p className="text-sm text-na-ink">Usamos cookies essenciais para a loja funcionar. Medição e marketing ficam desligados até você permitir.</p>
      {more && (
        <div className="mt-3 space-y-2 text-sm">
          <label className="flex items-center gap-2"><input type="checkbox" checked disabled /> Essenciais (sempre ativos)</label>
          <label className="flex items-center gap-2"><input type="checkbox" checked={prefs.medicao} onChange={(e) => setPrefs({ ...prefs, medicao: e.target.checked })} data-testid="cookie-medicao" /> Medição (Google Analytics)</label>
          <label className="flex items-center gap-2"><input type="checkbox" checked={prefs.marketing} onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} data-testid="cookie-marketing" /> Marketing (Meta Pixel)</label>
        </div>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <button className="btn-na px-4 py-2" onClick={() => save(more ? prefs : { medicao: true, marketing: true })} data-testid="cookie-accept">{more ? "Salvar escolhas" : "Aceitar todos"}</button>
        <button className="btn-line px-4 py-2" onClick={() => save({ medicao: false, marketing: false })} data-testid="cookie-essentials">Só essenciais</button>
        {!more && <button className="px-3 text-sm font-semibold text-na-forest underline" onClick={() => setMore(true)} data-testid="cookie-customize">Personalizar</button>}
      </div>
    </div>
  );
}
